import React, { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import theme, { sliceColourTheme } from '../../styles/theme';
import get from '../../helpers/get';
import Tile, { tileShape } from './Tile';
import { getSliceContent, getOurBrandsTiles, getSliceColourTheme } from '../../selectors';
import createSwitchingSideScroller from '../Scrollers/createSwitchingSideScroller';
import CtaButton from '../CtaButton';

class Tiles extends Component {
  state = {
    expanded: false,
  };

  onShowMore = () => {
    this.setState({ expanded: true });
  };

  renderTile = (tile, i, hideStackedItems) => {
    const {
      classes,
      isStackedOnMobile,
      dropShadow,
      backgroundColour,
      columns,
    } = this.props;

    return (
      <Tile
        key={i} // eslint-disable-line react/no-array-index-key
        dropShadow={dropShadow}
        backgroundColour={backgroundColour}
        isStackedOnMobile={isStackedOnMobile}
        className={cn(classes.tile, {
          stacked: isStackedOnMobile,
          hiddenInStack: hideStackedItems && i > 5,
          sixColumns: columns === '6 columns',
        })}
        {...tile}
      />
    );
  };

  render() {
    const {
      tiles,
      classes,
      isStackedOnMobile,
      hideExtraStakedItems,
    } = this.props;
    const { expanded } = this.state;

    const hideStackedItems = isStackedOnMobile && hideExtraStakedItems && !expanded;

    const MobileSideScroller = createSwitchingSideScroller('div', isStackedOnMobile ? 0 : 'md');
    return (
      <>
        <MobileSideScroller className={classes.wrapper} slideClassName={classes.tile}>
          {tiles.map((tile, i) => this.renderTile(tile, i, hideStackedItems))}
        </MobileSideScroller>
        {hideStackedItems && tiles.length > 6 && (
          <div className={classes.buttonContainer}>
            <CtaButton className={classes.button} defaultText="View More" onClick={this.onShowMore} />
          </div>
        )}
      </>
    );
  }
}

Tiles.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
  tiles: PropTypes.arrayOf(PropTypes.shape(tileShape)).isRequired,
  isStackedOnMobile: PropTypes.bool.isRequired,
  hideExtraStakedItems: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types -- used in injectSheet
  columns: PropTypes.string,
  dropShadow: PropTypes.bool,
  backgroundColour: PropTypes.string,
};

export const defaultBackgroundColour = sliceColourTheme.grey.backgroundColour;

Tiles.defaultProps = {
  columns: '4 Columns',
  dropShadow: true,
  backgroundColour: defaultBackgroundColour,
};

const mapStateToProps = (state, { sliceId }) => ({
  tiles: getOurBrandsTiles(state, sliceId),
  columns: get(getSliceContent(state, sliceId), ['number_of_columns']),
  dropShadow: get(getSliceContent(state, sliceId), ['drop_shadow']) !== 'No',
  backgroundColour: getSliceColourTheme(state, sliceId)
    ? sliceColourTheme[getSliceColourTheme(state, sliceId)].backgroundColour : undefined,
});

const tileColumnsStyle = (columns, breakpoint) => ({
  [theme.breakpoints.up(breakpoint)]: {
    width: `calc((100% - ${theme.padding.gutter * columns}px) / ${columns})`,
  },
  '&.stacked': {
    width: `calc(100% - ${theme.padding.gutter}px)`,
    [theme.breakpoints.up(320)]: {
      width: `calc(50% - ${theme.padding.gutter}px)`,
    },
    [theme.breakpoints.up(breakpoint)]: {
      width: `calc((100% - ${theme.padding.gutter * columns}px) / ${columns})`,
    },
    '&.hiddenInStack': {
      display: 'none',
      [theme.breakpoints.up(breakpoint)]: {
        display: 'block',
      },
    },
  },
});

const mobileWidth = 220;
export default compose(
  connect(mapStateToProps),
  injectSheet({
    wrapper: {
      // negative bottom margin to soak up the bottom margin of the last row of tiles
      marginTop: 24 - theme.padding.gutter,
      marginBottom: -theme.spacing.vertical.sm,
    },
    tile: {
      marginTop: theme.padding.gutter / 2,
      marginLeft: theme.padding.gutter / 2,
      marginRight: theme.padding.gutter / 2,
      flex: '0 0 auto',
      width: mobileWidth,
      ...tileColumnsStyle(4, 'md'),
      '&.sixColumns': {
        ...tileColumnsStyle(6, 768),
      },
    },
    buttonContainer: {
      display: 'block',
      textAlign: 'center',
      marginTop: 32,
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    button: {
      cursor: 'pointer',
    },
  }),
)(Tiles);
